// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "rec-" + chunkId + "." + {"34":"63cfc8d1","324":"38962622","548":"a9f53dbc","606":"42696530","650":"cf01dcc1","672":"96fa2179","686":"4902aa74","907":"27bae895","978":"02b83082"}[chunkId] + ".js";
};